import React, { useState, ChangeEvent, useRef, KeyboardEvent } from "react"
import { useDispatch } from "react-redux"
import { IconEdit } from "dash-styled"
import { updateInstanceName } from "../../../../../../Actions/API/AppInstance/AppInstanceActions"

interface EditableTitleProps {
    appID: string
    instanceName: string
    disabled?: boolean
}

export function InstanceNameViewEdit({
    appID,
    instanceName,
    disabled
}: EditableTitleProps) {
    const [isEditing, setEditing] = useState(false)
    const [newName, setNewName] = useState("")
    const dispatch = useDispatch()
    const textareaRef = useRef<HTMLTextAreaElement>(null)
    const handleClickEdit = () => {
        setEditing(true)
        setNewName(instanceName || "")
        requestAnimationFrame(() => {
            if (textareaRef.current !== null) {
                const len = (instanceName || "").length

                textareaRef.current.focus()
                textareaRef.current.setSelectionRange(0, len)
            }
        })
    }
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) =>
        setNewName(e.target.value)
    const finishEditing = () => {
        setEditing(false)

        if (instanceName !== newName && newName !== "") {
            dispatch(updateInstanceName(appID, newName))
        }
    }
    const handleKeyDownTextArea = (e: KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key !== "Enter") {
            return
        }

        e.preventDefault()
        finishEditing()
    }

    if (isEditing) {
        return (
            <textarea
                ref={textareaRef}
                rows={3}
                className="border-none bg-transparent p-0 w-full"
                style={{
                    fontSize: "inherit",
                    fontFamily: "inherit",
                    fontWeight: "inherit",
                    color: "inherit"
                }}
                value={newName}
                onChange={handleChange}
                onKeyDown={handleKeyDownTextArea}
                onBlur={finishEditing}
                maxLength={64}
                data-testid="instance-name-edit-textarea"
            />
        )
    }

    const name = newName === "" ? instanceName : newName
    const namePrefix = name.replace(/\s+[^\s]+$/, "")
    const nameSuffix = name.replace(namePrefix, "")

    return disabled ? (
        <span data-testid="instance-name">{instanceName}</span>
    ) : (
        <button
            onClick={handleClickEdit}
            data-testid="instance-name"
            className="group break-words block w-full relative text-left p-0 font-semibold"
        >
            {namePrefix}
            <span className="whitespace-no-wrap">
                {nameSuffix}
                <IconEdit
                    size="md"
                    className="inline invisible group-hover:visible pointer-events-none ml-2 text-smoke-350 cursor-pointer mb-1"
                />
            </span>
        </button>
    )
}
